import styled from 'styled-components';
import { LayoutProps, SizeProps, SpaceProps, layout, size, space } from 'styled-system';

export const BlankButton = styled.button<SizeProps & SpaceProps & LayoutProps>`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  ${size}
  ${space}
  ${layout}
`;
